module.exports = __webpack_public_path__ + "static/media/jmsm.a7b35d7e.png";